import { render, staticRenderFns } from "./form.vue?vue&type=template&id=21851bfd&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=21851bfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21851bfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21851bfd')) {
      api.createRecord('21851bfd', component.options)
    } else {
      api.reload('21851bfd', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=21851bfd&scoped=true&", function () {
      api.rerender('21851bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/center/form.vue"
export default component.exports